import dayjs from 'dayjs';

import EditOfferPaymentModal from '../EditOfferPaymentModal';

const PrecoEditPaymentModal = ({
  schedule,
  setSchedule,
  expirationDate,
  ...props
}) => {
  const handleEdit = (initialDate, payment) => {
    const updatedSchedule = schedule
      .map((scheduledPayment) =>
        dayjs(scheduledPayment.date).isSame(dayjs(initialDate))
          ? {
              ...payment,
              changeType: 'edit',
              original: scheduledPayment.original ?? {
                amount: scheduledPayment.amount,
                date: scheduledPayment.date,
              },
            }
          : scheduledPayment,
      )
      .sort((a, b) => dayjs(a.date) - dayjs(b.date));

    setSchedule(updatedSchedule);
  };

  const handleAdd = (payment) => {
    const updatedSchedule = [
      ...schedule,
      { ...payment, changeType: 'add' },
    ].sort((a, b) => dayjs(a.date) - dayjs(b.date));

    setSchedule(updatedSchedule);
  };

  return (
    <EditOfferPaymentModal
      {...props}
      expirationDate={expirationDate}
      onEditPayment={handleEdit}
      onAddPayment={handleAdd}
      formId="precoEditPaymentForm"
    />
  );
};

export default PrecoEditPaymentModal;
